export const DEFAULT_CONTACT_GOAL = 10
export const DEFAULT_CONTRIBUTION_GOAL = 400

/* Disney trip raffle (CAX-3160): sending this many invites earns one raffle entry. */
export const DISNEY_CONTACT_GOAL = 15
export const DISNEY_TOS_URL = 'https://booksarefun.com/disney-trip-details-f26-s27'
